import { SvgIconProps } from "@mui/material";

export const ScissorsIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M3 7a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
    <path d="M3 17a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
    <path d="M8.6 8.6l10.4 10.4" />
    <path d="M8.6 15.4l10.4 -10.4" />
  </svg>
);
